<div class="month-range-container">
  <div class="date-header">{{headerName}}</div>
  <div class="year-selection">
    <div class="year-panel">
      <!-- <label>Left Year</label> -->
      <!-- <select [(ngModel)]="leftYear" (change)="updateLeftMonths()">
        <option *ngFor="let year of allYears" [ngValue]="year">{{ year }}</option>
      </select> -->
      <app-material-calendar
      [minYear]="minYear"
      [maxYear]="maxYear"
      [selectedYear]="startYear"
      [disabledYears]="disabledYearsForStartSelector"
      (yearSelected)="onStartYearSelected($event)"
    ></app-material-calendar>
    </div>
    <div class="year-panel">
      <!-- <label>Right Year</label> -->
      <!-- <select [(ngModel)]="rightYear" (change)="updateRightMonths()">
        <option *ngFor="let year of allYears" [ngValue]="year">{{ year }}</option>
      </select> -->
      <app-material-calendar
      [minYear]="minYear"
      [maxYear]="maxYear"
      [selectedYear]="endYear"
      [disabledYears]="disabledYearsForEndSelector"
      (yearSelected)="onEndYearSelected($event)"
    ></app-material-calendar>
    </div>
  </div>


  <div class="month-range-calendar">
    <div class="month-range-panel">
      <div class="month-range-grid">
        <div  class="month-range" *ngFor="let month of leftMonths">
        <div class="month-range-button-highlight" [class.in-range]="isInRange(month)" 
        [class.leftcurve]="month.includes('Jan')||month.includes('May')||month.includes('Sep')||month.includes(selectedStartMonth)"
        [class.rightcurve]="month.includes('Apr')||month.includes('Aug')||month.includes('Dec')||month.includes(selectedEndMonth)" >
          <button class="month-range-button"
          [class.selected]="isSelected(month)"
          [class.leftdisabled]="isDisabled(month)"
          [class.range]="isInRange(month)"
          [class.buttonleftcurve]="month.includes('Jan')||month.includes('May')||month.includes('Sep')||month.includes(selectedStartMonth)"
          [class.buttonrightcurve]="month.includes('Apr')||month.includes('Aug')||month.includes('Dec')||month.includes(selectedEndMonth)"
           (click)="selectMonth(month,'start')">
            {{ month.split(' ')[0] }}
          </button>
        </div>
      </div>
      </div>
    </div>

    <div class="divider"></div>

    <div class="month-range-panel">
      <div class="month-range-grid">
        <div  class="month-range" *ngFor="let month of rightMonths">
        <div  class="month-range-button-highlight"   [class.in-range]="isInRange(month)"  
        [class.leftcurve]="month.includes('Jan')||month.includes('May')||month.includes('Sep')||month.includes(selectedStartMonth)"
        [class.rightcurve]="month.includes('Apr')||month.includes('Aug')||month.includes('Dec')||month.includes(selectedEndMonth)">
          <button class="month-range-button" 
          [class.selected]="isSelected(month)"
          [class.buttonleftcurve]="month.includes('Jan')||month.includes('May')||month.includes('Sep')||month.includes(selectedStartMonth)"
          [class.buttonrightcurve]="month.includes('Apr')||month.includes('Aug')||month.includes('Dec')||month.includes(selectedEndMonth)"
          [class.range]="isInRange(month)"
          [class.leftdisabled]="isDisabled(month)"
           (click)="selectMonth(month,'end')">
            {{ month.split(' ')[0] }}
          </button>
        </div>
      </div>
      </div>
    </div>
  </div>

  <div class="date-inputs">
    <div class="input-group">
      <span class="input-group-text">Start Date</span>
      <input type="text" class="form-control" [value]="selectedStartMonth ? (getMonthStartDate(selectedStartMonth) | date:'MM.dd.yyyy') : ''" readonly />
    </div>
    <div class="input-group">
      <span class="input-group-text">End Date</span>
      <input type="text" class="form-control" [value]="selectedEndMonth ? (getMonthEndDate(selectedEndMonth) | date:'MM.dd.yyyy') : ''" readonly />
    </div>
  </div>

  <div class="actions">
    <button matTooltip="Clear Selection" class="btn clear" (click)="clearDates()">Clear</button>
    <button matTooltip="Apply Selection" class="btn apply" cdkMenu  [disabled]="!selectedStartMonth || !selectedEndMonth" (click)="applyDates()">Apply</button>
  </div>
</div>